/* eslint-disable no-console */
const getActiveStyleGroups = (variants: any[] = []) => (
  variants.
    find(variant => variant.selected && variant.styleGroups)?.
    styleGroups ?? []
);


const getNewGroup  = (group: any, selectedSize: { [parameter: string]: any; },) => {
  const newGroup = { ...group };
  // Make sure that each style group has sizes, and that it's an array
  if (!newGroup.sizes || !Array.isArray(newGroup.sizes)) {
    console.warn(
      'Data malformed -> styleGroup has no sizes, or sizes are not an array'
    );
    console.warn(newGroup.sizes);

    return newGroup;
  }


  newGroup.sizes = newGroup.sizes.map((size: { name: string; selected: boolean; }) => {
    const newSize = size;

    // Since multiple sizes can be selected at once, we need to preserve
    // previously selected sized by only changing the current size
    if (size.name === selectedSize.name) {
      // This will allow us to toggle a size on and off
      newSize.selected = !newSize.selected;
    }

    return newSize;
  });
  
  return newGroup;
};


const selectSizeForStyleGroup = (
  selectedStyleGroup: { [parameter: string]: any; },
  selectedSize: { [parameter: string]: any; },
  styleGroups: any[],
) => {
  // Make sure that styleGroups was passed in as an array
  if (!Array.isArray(styleGroups)) {
    console.warn('Data malformed -> styleGroups is not an array');
    console.warn(styleGroups);

    return [];
  }

  return styleGroups.map(styleGroup => {
    const newGroup = styleGroup;

    if (newGroup.name === selectedStyleGroup.name) getNewGroup(newGroup, selectedSize);
    return newGroup;
  });
};

const selectSizeVariant = (selectedSizeVariant: { name: string; }, sizeVariants: any[] = []) =>
  sizeVariants.map(sizeVariant => {
    const newVariant = sizeVariant;

    // Only one variant can be selected at a time. This will reset the non-current
    // variants to false while only setting the current variant to true
    newVariant.selected = newVariant.name === selectedSizeVariant.name;
    return newVariant;
  });

export { getActiveStyleGroups, selectSizeForStyleGroup, selectSizeVariant };
